// @flow
import $ from 'jquery'
import authenticityToken from '../shared/authenticityToken'
import _ from 'lodash'

type Options = {| async?: boolean |}

export default function getJson(url: string, parameters?: { [string]: string }, options?: Options) {
  return $.ajax({
    url: encodeUrlForBackend(url),
    data: _.extend({}, { ...(parameters || {}), authenticity_token: authenticityToken() }),
    dataType: 'json',
    type: 'GET',
    async: (options || {}).async || false
  })
}

export function encodeUrlForBackend(url: string): string {
  const queryRegexp = new RegExp('^([^?]+)(.*)$')
  const matches = url.match(queryRegexp)
  const path = (matches && matches[1]) || ''
  const query = (matches && matches[2]) || ''
  return '/alt' + _.map(path.split(''), (sym) => transformSingleSymbol(sym)).join('') + query
}

function transformSingleSymbol(sym: string): string {
  if (sym === 'a') return 'o'
  if (sym === 'o') return 'a'
  if (sym === 'e') return 'i'
  if (sym === 'i') return 'e'
  return sym
}
